import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const VirtualMachinesAndVirtualization = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Virtual Machines and Virtualization"
    videos={[
      "https://www.youtube.com/embed/bTY4DrkLhW8?si=wwjYnOVEDc_divIC",
      "https://www.youtube.com/embed/MnU-t31MtRY?si=vCXujgQVrTt01lAc",
      "https://www.youtube.com/embed/uKKfx3MWoXU?si=s_GNuIvkOLxdUwZJ",
      "https://www.youtube.com/embed/KJzgJk1rdSs?si=hkHdtIYH0FqYo7rd",
      "https://www.youtube.com/embed/T7_y3ZBS5LU?si=dr7buCgc5LrFpFEK",
      "https://www.youtube.com/embed/KV57x86MNj0?si=pW_EUQC8LBtvecgC",
      "https://www.youtube.com/embed/ABrXGwNsFfA?si=9XZh4g0O-xrZka8U",
      "https://www.youtube.com/embed/73XTW67TOZ0?si=vWhs2iDrvAtGvWk3",
      "https://www.youtube.com/embed/1Pmn3tEZTCw?si=OVZhz0LD2XLwucDH"
    ]}
    takeaways={[]}
    questions={[
      "1) Compare and contrast Hypervisor 0, Hypervisor 1 and Hypervisor 2.",
      "2) Compare and contrast the following hypervisors: Xen, KVM, Oracle VM and VMWare ESXi based on the support provided by: Paravirtualization, Full Virtualization, Host CPU, Guest CPU, Host OS, Guest OS, VT-x/AMD-v, Live Migration, License",
      "3) Explore the different types of virtualization, such as hardware virtualization, operating system virtualization, and paravirtualization. Analyze the unique benefits and challenges associated with each type, and evaluate their impact on system efficiency and resource management. In what scenarios might one type of virtualization be more advantageous than the others? Justify your recommendations with real-world examples."
    ]}
    exampleVideos={[]}
  />
);
}

export default VirtualMachinesAndVirtualization;
